module.exports = __webpack_public_path__ + "media/images/subject_img/CIVIL ENGINEERING-cb025cd10d5ef6b2bdee591a634f83b9.jpg";